import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import App from './App'
import './index.css'
import './config/envConfig'

// Import FullStory initialization
import {initFullStory} from './components/FullStory/initFullStory'

import {Provider} from 'react-redux'
import {store} from './store'

// Initialize FullStory
initFullStory()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>,
)
